module.exports = __webpack_public_path__ + "static/media/evRiesg_1.ff179083.png";